import React from 'react';
import logo from './../assets/MSLogo_Lg.gif';

/**
 * Renders the logo that is in the footer
 */
const FooterLogo = () => {
  return <img src={logo} alt="Magical Strings logo" className="footer__logo" />;
};

export default FooterLogo;
